import { render, staticRenderFns } from "./DataRange.vue?vue&type=template&id=3a147842&scoped=true"
import script from "./DataRange.vue?vue&type=script&lang=js"
export * from "./DataRange.vue?vue&type=script&lang=js"
import style0 from "./DataRange.vue?vue&type=style&index=0&id=3a147842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a147842",
  null
  
)

export default component.exports